export default __webpack_public_path__ + "static/media/trus16.1477e68c.png";